import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What happened to React + D3v4?",
  "description": "",
  "published": "2017-05-10T00:00:00.000Z",
  "redirect_from": ["/blog/wheres-react-d3v4/swizec/7594"],
  "categories": "Business, Side Projects, Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "fk7QJuVK3FM",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`In December or November last year, I made a string of big promises. I'm gonna have the `}<a parentName="p" {...{
        "href": "https://gum.co/mTWg"
      }}>{`all new version of React+D3v4`}</a>{` ready by Christmas, it's gonna be amazing, there's an interactive video course coming in January or February, and a brand new D3v4 cheatsheet. All the things!`}</p>
    <p>{`It is now May.`}</p>
    <p>{`All I've achieved is that I pissed off my girlfriend. Working over Christmas was a dumb idea, and I'm dumb for having thought of it.`}</p>
    <p>{`Book… good progress, valiant effort, still not done. I have all the new examples and projects. I've finished all the theoretical parts and the big fat practical part. I've done the animation bits as well.`}</p>
    <p>{`Interactive course and videos… haven't even started. Gotta finish the source book first!`}</p>
    <p>{`Here's what happened:`}</p>
    <p>{`In November, I started talking with Shoutem, and we came up with `}<a parentName="p" {...{
        "href": "http://reactnative.school"
      }}>{`React Native School`}</a>{`. Originally my plan was to finish React+D3v4, leave a month of buffer to recuperate, then dive into building a new React Native app every two weeks for React Native School.`}</p>
    <p>{`That did not quite work out. But I still had to start React Native articles in February. That's `}<a parentName="p" {...{
        "href": "http://reactnative.school"
      }}>{`been going pretty well`}</a>{`. New app almost every two weeks, the trip to Europe messed up my schedule a bit, but I'm getting back into it.`}</p>
    <p>{`Because of the increased workload though, I haven't been able to work on the book as much. Or at all, really.`}</p>
    <p><strong parentName="p">{`BUT`}</strong>{` on my flight back from Europe, I was able to touch up and fix the Redux animation particles example. It's shiny and useful and fits React 15.5.x now.`}</p>
    <p>{`Then over the last week of jetlag early mornings, I kept writing and writing, and now the canvas section is done. A whole brand new section on using HTML5 Canvas to build declarative bitmaps and making your animations speedy.`}</p>
    <p>{`Even finished the first React + Canvas example. The particle generator pushed to 20,000 elements. It's great.`}</p>
    <p>{`So here's the deal: By the end of this month, I'll have the book fully finished. The missing parts are:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://swizec.com/blog/n-body-collision-simulation-react-d3-mobx/swizec/7497"
        }}>{`n-body collision simulation with D3, MobX, and Canvas`}</a>{` example`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://swizec.com/blog/dancing-tree-fractal-react/swizec/7288"
        }}>{`Dancing tree fractal`}</a>{` and comparison of React alternatives`}</li>
      <li parentName="ul">{`some tips on performance`}</li>
    </ul>
    <p>{`That's it. That's all I have to write to finish the book. I can totally do that in the next 3 weeks even while doing React Native School. Especially because the two big chapters already exist as blog posts. That makes it easier.`}</p>
    <p>{`Wish me luck.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      